let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7IvTK")).then(() => parcelRequire('dGjHO'));